<template>
    <div v-show="isShow(routeArr)" @click="hidden" id="wxBack" :class="{changeBack : isDinner}" class="wxBack">
        返回&nbsp;&nbsp;
    </div>
</template>


<script>
import { mapState, mapGetters, mapMutations } from "vuex";
    export default {
        data () {
          return{
          	
            }
        },
        computed: {
		    ...mapState(["routeArr","isDinner"]),
		},
        watch:{
        	
        },
        mounted(){
        	if(this.$route.path.indexOf("wxDinner") != -1){
        		this.ADD_RETOR("/data/wxDinner/"+window.localStorage.getItem("wxCode"));
        	}
        },
        methods:{
        	isShow(e){
        		if(e.length>1){
        			return true;
        		}else{
        			return false;
        		}
        	},
        	hidden(){
        		this.DEL_RETOR();
        		this.$router.push(this.routeArr[this.routeArr.length-1]);
//      		alert(this.routeArr[this.routeArr.length-1])
        	},
        	...mapMutations(["DEL_RETOR","ADD_RETOR"])   
        }
    }
</script>

<style lang="scss">
    .wxBack{
        position: absolute;
        width: 50px;
        height: 50px;
        line-height: 35px;
        z-index: 99;
        font-size: 18px;
        color: #fff;
        background: skyblue;
        border-bottom-right-radius: 100%
    }
    .changeBack{
    	left: 5%;
        top: 16vw;
    }
</style>



// WEBPACK FOOTER //
// src/components/wxBack.vue